module.exports = __webpack_public_path__ + "static/media/203.8cd9804b.png";